import React from "react";

import { Title } from "~/components";
import { env } from "~/env";
import AuthBanner, { BannerTypes } from "~/screens/Auth/components/AuthBanner";
import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { usePageTitle } from "~/shared";

export const ErrorBoundary = () => {
  usePageTitle("Something went wrong");

  return (
    <AuthLayout banner={<AuthBanner type={BannerTypes.crashError} />}>
      <section className="flex w-full items-center justify-center px-8 pb-8 xl:px-0">
        <div className="w-full max-w-lg bg-white py-2">
          <section className="space-y-6">
            <Title>Uh-oh! Looks like there’s an error on our end</Title>

            <p className="text-indigo font-neue mb-3 font-medium">
              If the problem persists, mind letting us know so we can be sure to
              fix it ASAP? Email{" "}
              <a
                href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
                target="_blank"
                aria-label={`${env.VITE_ELEKTRA_CARE_EMAIL} (opens in a new tab)`}
                className="text-indigo font-neue underline"
              >
                {env.VITE_ELEKTRA_CARE_EMAIL}
              </a>
            </p>
          </section>
        </div>
      </section>
    </AuthLayout>
  );
};
